import { motion } from 'framer-motion';

import { howItWorks } from '@marketing/data/howItWorks';
import { StepIcon } from '@marketing/illustrations/StepIcon';
import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// HowItWorksTimeline — 5 passos conectados
// ============================================================

export function HowItWorksTimeline() {
  return (
    <section
      id="como-funciona"
      className="lume-section"
      aria-labelledby="how-title"
    >
      <div className="lume-container">
        <motion.header
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-stack lume-stack-md"
          style={{ marginBottom: 'clamp(2rem, 4vw, 3rem)', maxWidth: '48rem' }}
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">Como funciona</motion.p>
          <motion.h2 variants={fadeUp} id="how-title" className="lume-h2 lume-text-balance">
            Do toque do paciente ao painel do médico — em 5 passos
          </motion.h2>
        </motion.header>

        <motion.ol
          {...revealOnView}
          variants={stagger(0.1)}
          className="lume-timeline"
          style={{ listStyle: 'none', padding: 0, margin: 0 }}
        >
          {howItWorks.map((step) => (
            <motion.li
              key={step.id}
              variants={fadeUp}
              className="lume-timeline__step"
            >
              <div style={{ marginBottom: '0.85rem' }}>
                <StepIcon iconKey={step.iconKey} />
              </div>
              <h3 className="lume-h3" style={{ fontSize: '1.05rem' }}>
                {step.title}
              </h3>
              <p
                style={{
                  marginTop: '0.4rem',
                  fontSize: '0.92rem',
                  color: 'var(--color-fg-muted)',
                  lineHeight: 1.55,
                }}
              >
                {step.body}
              </p>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  );
}
